export enum ChargingStatus {
  Available = 0,
  Preparing = 1,
  Charging = 2,
  SuspendedEV = 3,
  SuspendedEVSE = 4,
  Finishing = 5,
  Unavailable = 6,
  Faulted = 7,
  Occupied = 8,
  Reserved = 9,
  Active = 10,
  Unknown = 99
}
